import Vue from "vue";
import VueWait from "vue-wait";
import vLoading from "vue-wait/src/components/v-wait.vue";

Vue.component("v-wait", vLoading);

Vue.use(VueWait); // add VueWait as Vue plugin
